/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SMSRefreshIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'SMSRefresh',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 4.1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5l3.536 6.839a.5.5 0 0 0 .928 0l2.581-4.992a12.131 12.131 0 0 1 1.437-9.2c-.009-.021-.027-.029-.035-.052a431.388 431.388 0 0 1-1.74-6.75 628.034 628.034 0 0 1-.248 6.643l-.006.133-.131.238-.314.119-2.035.012-.189-.461.639-11.41.457-.146 2.676-.008a.547.547 0 0 1 .543.367c.272.945 1.275 4.518 1.856 6.859.353-1.24.848-2.871 1.273-4.277.316-1.043.6-1.973.762-2.539l.027-.061.121-.176.275-.15 2.941-.024.207.369.248 5.8a12.255 12.255 0 0 1 2.109-.378 3.262 3.262 0 0 1-.967-2.385c0-2.174 1.646-3.578 4.2-3.578a5.914 5.914 0 0 1 2.631.477.539.539 0 0 1 .315.559v1.955l-.4.145-.242-.016a4.581 4.581 0 0 0-2.3-.535c-.443 0-1.475.082-1.475.842 0 .334.109.684 1.42 1.287l.613.271a5.033 5.033 0 0 1 2.531 2.108A12.27 12.27 0 0 1 34 16.993V5.1a1 1 0 0 0-1-1ZM6.66 21.245a6.547 6.547 0 0 1-3.006-.613.658.658 0 0 1-.314-.611v-2.066l.406-.129a6.437 6.437 0 0 0 2.967.848c.688 0 1.51-.158 1.51-.908 0-.336-.109-.717-1.41-1.359l-.725-.318C4.16 15.184 3.34 14.1 3.34 12.469c0-2.174 1.647-3.578 4.2-3.578a5.9 5.9 0 0 1 2.631.477.539.539 0 0 1 .314.559v1.955l-.4.145-.242-.016a4.541 4.541 0 0 0-2.3-.535c-.443 0-1.475.082-1.475.842 0 .334.109.684 1.42 1.287l.613.271c2.072.951 2.953 2.062 2.953 3.719-.005 2.218-1.728 3.65-4.394 3.65ZM20.288 16.8c.271-.177.544-.349.828-.5-.01-.815-.018-1.61-.022-2.318-.25.885-.529 1.856-.806 2.818Z"
    />
    <path
      d="M27.1 33.463a6.143 6.143 0 0 1-4.718-2.1l2.282-2.287H18.2v6.477l2.476-2.481A8.648 8.648 0 0 0 27.1 36a9.2 9.2 0 0 0 8.9-8.9h-2.255a6.812 6.812 0 0 1-6.645 6.363ZM33.585 21.126A9.112 9.112 0 0 0 27.1 18.2a9.2 9.2 0 0 0-8.9 8.9h2.255a6.812 6.812 0 0 1 6.645-6.364 6.214 6.214 0 0 1 4.817 2.093l-2.245 2.293H36V18.66Z"
    />
  </svg>`;
};
